module.exports = __webpack_public_path__ + "img/rukavy_81_sharp-zelena.c1f325d4.png";